import React, { useContext, useEffect, useState } from "react";
import WebsocketWrapperContext from "../../../context/WebsocketWrapperContext";

let triggerSubscribe = true;
let connectionEstablised = false;

const IndianMarketsTable = ({ data }) => {
  const [symbols, setSymbols] = useState();

  const {
    checkWebsocketConnection,
    subscribeToSymbols,
    symbolList,
    symbolData,
  } = useContext(WebsocketWrapperContext);

  useEffect(() => {
    if (data && data.indian_markets && data?.indian_markets?.length > 0) {
      const symbols = data.indian_markets.map((item) => item.code);
      setSymbols(symbols);
    }
  }, [data]);

  function formatNumberWithCommasAndFontWeight(value) {
    const formattedValue = parseFloat(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const parts = formattedValue?.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1];

    return (
      <span>
        {integerPart}.<span className="font-normal">{decimalPart}</span>
      </span>
    );
  }

  useEffect(() => {
    connectionEstablised = checkWebsocketConnection();
    if (connectionEstablised && symbols?.length > 0) {
      if (triggerSubscribe) {
        subscribeToSymbols(symbols, "NSE");
        if (Object.keys(symbolList).length !== 0) {
          triggerSubscribe = false;
        }
      }
    } else {
      triggerSubscribe = true;
    }
  }, [symbolData]);

  const getStatusColor = (status) => {
    return status === "Open" ? "text-p150" : "text-red";
  };

  const getChangeColor = (changeValue) => {
    return parseFloat(changeValue) > 0 ? "text-p150" : "text-red";
  };

  return (
    <div className="flex flex-col">
      <div className="w-full rounded-lg bg-p400 shadow">
        <div className="pt-4 pb-2">
          <div className="mb-1 px-4">
            <h1 className="text-lg font-semibold text-p300">Indian markets</h1>
            <p className="text-sm font-medium text-n500">
              Tracking Indian cues help to analyse
            </p>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full table-auto px-4">
            <thead>
              <tr className="border-b border-n100">
                <th className="py-3 px-4 text-left">
                  <span className="text-sm font-medium text-n500">Index</span>
                </th>
                <th className="py-3 px-4 text-left">
                  <span className="text-sm font-medium text-n500">Points</span>
                </th>
                <th className="py-3 px-4 text-right">
                  <span className="text-sm font-medium text-n500">
                    Chg (Chg %)
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.indian_markets &&
                data.indian_markets.map((item, index) => (
                  <tr key={index}>
                    <td className="py-3 px-4">
                      <div className="flex items-center">
                        <span
                          className={`text-base mr-1 ${getStatusColor(item.status)}`}>
                          ●
                        </span>
                        <span className="text-sm font-medium text-p300">
                          {item.symbol.toUpperCase()}
                        </span>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <span className="text-sm font-semibold text-p300">
                        {formatNumberWithCommasAndFontWeight(item.ltp)}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-right">
                      <div className="flex justify-end items-center">
                        <span className="text-sm font-medium text-p300 mr-1">
                          {formatNumberWithCommasAndFontWeight(
                            item.change_value
                          )}
                        </span>
                        <span
                          className={`text-sm font-medium ${getChangeColor(item.change_per)}`}>
                          (
                          {formatNumberWithCommasAndFontWeight(item.change_per)}
                          %)
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default IndianMarketsTable;
